import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';
const { WHITE, PURPLE, LIGHT_PURPLE, FONT_COLOR, ERROR } = colors;
import { Bogle_Medium } from 'constants/constant';

const PreviewDialogStyle = makeStyles(() => ({
	container: {
		padding: 16
	},
	content: {
		minWidth: 444
	},
	tittlePadding: {
		padding: '16px 16px 8px 16px'
	},
	contentPadding: {
		padding: '8px 16px 8px 16px'
	},
	actionBtnPadding: {
		padding: '8px 16px 16px 16px'
	},
	button: {
		height: 40,
		textTransform: 'none',
		fontSize: 14,
		borderRadius: 20,
		marginLeft: '16px !important',
		width: 'fit-content',
		fontWeight: 600,
		color: PURPLE,
		fontFamily: Bogle_Medium,
		cursor: 'pointer'
	},
	applyBtn: {
		background: PURPLE,
		color: WHITE,
		'&:hover': {
			backgroundColor: LIGHT_PURPLE
		}
	},
	continueBtn: {
		display: 'flex',
		border: '1px solid',
		'&:hover': {
			color: WHITE,
			backgroundColor: LIGHT_PURPLE
		}
	},
	dialogTitle: {
		fontSize: 22,
		fontFamily: `${Bogle_Medium} !important`,
		color: FONT_COLOR
	},
	dialogContent: {
		fontSize: 16,
		fontFamily: `${Bogle_Medium} !important`,
		color: FONT_COLOR
	},
	reportNameError: {
		color: ERROR,
		display: 'flex',
		marginLeft: 0,
		justifyContent: 'unset'
	}
}));

export default PreviewDialogStyle;
